import { ContentBlockFragment } from '@graphqlTypes/sitecore';
import { ContentBlockWithSection } from '@mobx/stores/calendar-store';
import { PreviewTrackedArticleInfo, TrackedArticleInfo } from '@src/adobe-launch/global';
import { DiscoverTemplates } from '@src/common/enums';
import { format } from 'date-fns';

// export function useArticleTracker(articleDetail: DetailFragment) {
//     const info = useMemo(() => {
//         return convertArticleInfo(articleDetail);
//     }, [articleDetail]);

//     usePageTrackers(info);
// }

/** 封装通用下发数据
 * - `title`
 * - `guid`
 * - `startDate`
 * - `categories`
 * - `hashtags`
 * - `segmentCodes`
 * - `accountListCodes`
 * - `publish_date`
 */
export function convertArticleInfo(
    contentBlock: ContentBlockFragment | undefined | ContentBlockWithSection | any
): TrackedArticleInfo | undefined {
    if (!contentBlock) {
        return undefined;
    }
    const title = contentBlock.pageTitle?.value || contentBlock.calendarTitle?.value || '';
    const guid = contentBlock.id;
    const startDate = contentBlock.startDatetime?.dateValue;
    const categories = contentBlock.category?.categories;
    const hashtags = contentBlock.hashTags?.tags;
    const segmentCodes = contentBlock.segmentCodes?.targetItems || [];
    const accountListCodes = contentBlock.accountListCodes?.targetItems || [];

    const publish_date = startDate ? format(startDate, 'yyyy-MM-dd') : '';
    const category =
        categories
            ?.filter(
                (c: { __typename: DiscoverTemplates }) =>
                    c.__typename === DiscoverTemplates.category
            )
            .map((c: { name: any }) => c.name)
            .join(',') || '';
    const sub_category =
        categories
            ?.filter(
                (c: { __typename: DiscoverTemplates }) =>
                    c.__typename === DiscoverTemplates.subcategory
            )
            .map((c: { name: any }) => c.name)
            .join(',') || '';
    const tag = hashtags?.map((t: { name: any }) => t.name).join(',') || '';

    const segment_codes =
        segmentCodes
            ?.filter(
                (c: { __typename: DiscoverTemplates }) =>
                    c.__typename === DiscoverTemplates.segmentCodes
            )
            .map((c: { name: any }) => c.name)
            .join(',') || '';

    const account_list_codes =
        accountListCodes
            ?.filter(
                (c: { __typename: DiscoverTemplates }) =>
                    c.__typename === DiscoverTemplates.accountListCodes
            )
            .map((c: { name: any }) => c.name)
            .join(',') || '';

    return {
        title,
        guid,
        publish_date,
        category,
        sub_category,
        tag,
        segment_codes,
        account_list_codes,
    };
}
/** 封装通用下发数据
 * - `title`
 * - `guid`
 * - `startDate`
 * - `categories`
 * - `hashtags`
 * - `segmentCodes`
 * - `accountListCodes`
 * - `publish_date`
 */
export function previewPageConvertArticleInfo(
    contentBlock: ContentBlockFragment | undefined | ContentBlockWithSection | any
): PreviewTrackedArticleInfo | undefined {
    if (!contentBlock) {
        return undefined;
    }
    const title = contentBlock.pageTitle?.value || '';
    const id = contentBlock.id || '';

    return {
        content: {
            title,
            id,
        },
    };
}
